import React from 'react';
import { Link } from 'react-router-dom';

export const SiteNotFound: React.FC = () => {
  return (
    <div className="page-container flex items-center justify-center">
      <div className="text-center animate-fade-in">
        <h2 className="text-2xl font-bold text-gray-900">Site not found</h2>
        <p className="mt-2 text-gray-600">
          The site you're looking for doesn't exist or you don't have access to it.
        </p>
        <Link to="/dashboard" className="mt-4 btn-primary inline-block">
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
};
